import { Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';

const useStyles = makeStyles(theme => ({
  toolbarContainer: {
    background: theme.palette.background.paper,
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.spacing(2),
    padding: theme.spacing(2),
    alignItems: 'center',
    display: 'flex',
  },
  toolbarAligner: {
    display: 'flex',
    justifyContent: 'center',
  },
  fullWidth: {
    width: '100%',
  },
}));

export const Toolbar = ({ children, toolbarContainerStyle, left, fullWidth = false }: {
  children: any,
  toolbarContainerStyle?: any,
  left?: any,
  fullWidth?: boolean
}) => {
  const classes = useStyles();
  return (
    <Box className={`grid-toolbar ${classes.toolbarContainer}`} style={toolbarContainerStyle} justifyContent={left ? 'space-between' : 'flex-end'}>
      {left && <Box className={classes.toolbarAligner}>
        {left}
      </Box>}
      <Box pr={1} className={clsx(classes.toolbarAligner, fullWidth && classes.fullWidth)}>
        {children}
      </Box>
    </Box>
  );
};
